import React from 'react';
import Dict from 'dict-lib';
import {Button, Grid, Row, Col, Glyphicon} from 'react-bootstrap';
import {SCCheckbox} from "../../dict-components/checkbox/SCCheckbox";
import {arrayMove, SortableContainer, SortableElement, SortableHandle} from "react-sortable-hoc";
import stylesCgrData from './../../_css/dictionary/CgrData.module.css';
import BUtils from './../../utilities/BaseUtilities';
import {EditLanguage} from "./EditLanguage";
import stylesSorter from "../../_css/sorter.module.css";
import {Notifications} from "../../utilities/DictUtilities";


export class EditCgrs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: '',
            id: '',
            create: false,
            description: []
        };

        this._newItem = {id: -1, label: ""};

        this._getCgrData = this._getCgrData.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.reset === true) {
            this.setState({data: '', id: '', create: false});
        } else if (this.props.create === true && prevState.create === false) {
            this._getCgrData(this._newItem, -1);
        } else if (Object.keys(this.props.savedInfos).length > 0) {
            this._selectNewCgrItem(this.props.savedInfos);
        } 
    }

    _selectNewCgrItem(savedInfos) {
        var item = this.props.items.find((item) => {
            return item.id === savedInfos.id;
        });

        if (typeof item !== 'undefined') {
            var index = savedInfos.orderFactor;
            this._getCgrData(item, index);
        }
    }

    _getCgrData(item, index) {
        Dict.call('/cgr/getCgrData/' + item.id + '/' + this.props.language.id + '/').then((result) => {
            var data = {
                dataObject: result.dataObject,
                readOnlyDataObject: {forQuotation: this.props.forQuotation},
                className: this.props.className,
                specialFields: []
            };

            this.setState({data, id: item.id, create: item.id < 0});
            this.props.callBackChangeCgr(item.id);
        });
    }

    _changeData(changedData) {
        changedData.id = this.state.id;
        changedData.className = this.state.data.className;
        Object.assign(changedData, this.state.data.readOnlyDataObject);

        this.props.callBackChangeData(changedData);
    }

    render() {

        const isCreate = this.state.create;

        const DragHandle = SortableHandle(() => <div className="items-sortable-handle sortable-handle">
            <Glyphicon glyph="sort"/>
        </div>);

        const SortableItem = SortableElement(({item, index}) => {
            return (
                <Row>
                    <span className={stylesCgrData['column-list-cgr-button-sort']}><DragHandle/></span>
                    <Button key={'list-cgrs-' + index} onClick={() => this._getCgrData(item, index)}
                            bsClass={BUtils.joinClasses(stylesCgrData['column-list-cgr-button'], stylesCgrData[(item.id === this.state.id ? 'column-list-cgr-button--selected' : '')])}>
                        {item.label}
                    </Button>
                </Row>

                /*<div
                    className={BUtils.joinClasses(stylesSorter['items-sortable-item'], stylesSorter['sortable-item'])}>
                    <DragHandle/>
                    {value}
                </div>*/
            );
        });

        const SortableList = SortableContainer(({items}) => {
            return (
                <div className={"div-sortable-container sortable-type-CGR"}>
                    {items.map((item, index) => (
                        <SortableItem key={'sortable-item-' + index} index={index} item={item}/>
                    ))}
                </div>
            );
        });


        return <Grid className={stylesCgrData['column-list-cgrs-grid']} fluid>
            <Col lg={3} md={3} className={stylesCgrData['column-list-cgrs']}>
                <SortableList key={"key-lex-items-sortable"}
                              helperClass={stylesSorter['sortableHelper']} pressDelay={0} lockAxis={"y"}
                              useDragHandle={false}
                              items={this.props.items}
                              onSortStart={(obj) => {
                              }}
                              onSortEnd={(obj) => {
                                  var items = this.props.items;
                                  var sortedItems = arrayMove(items, obj.oldIndex, obj.newIndex);

                                  var ids = sortedItems.map((schild) => {
                                      return schild.id;
                                  }).join('_');

                                  this.props.callBackSortCgrs(sortedItems);
                                  Notifications.showWarningToastNotification("Attendi reset ordine c.gr.", 5000, 1000)
                                  Dict.call('/cgr/sortCgrs/' + ids + '/').then((result) => {
                                      if (result !== 'OK') {
                                          this.props.callBackSortCgrs(items);
                                          Notifications.showErrorModalMessage("Error", 2000);
                                      } else {
                                          Notifications.showToastNotification("Reset terminato", 3000, 0)
                                      }
                                  });
                              }}/>

            </Col>
            <Col lg={9} md={9} bsClass={stylesCgrData['column-edit-cgr']}>{this.state.data === '' ? '' :
                <div className={stylesCgrData['column-list-cgr-edit-container']}>
                    <Row
                        className={stylesCgrData['column-list-cgr-edit-bar']}>{Dict.t(isCreate ? 'NEW_CGR' : 'EDIT')}</Row>
                    <Row className={stylesCgrData['column-list-cgr-edit-row']}>
                        <EditLanguage key={'key-edit-cgr-' + this.state.id} data={this.state.data}
                                      language={this.props.language}
                                      callBackChangeData={(changedData) => this._changeData(changedData)}/>
                    </Row>
                </div>}
            </Col>
        </Grid>;
    }

}
